<template>
  <div class="common-content">
    <ul>
      <li
        v-for="(item, index) in article"
        :key="index"
        @click="detail(item.newsId)"
      >
        <div class="content-item" style="margin-left: 10px">
          <a href="javascript:;">
            <div class="common-content-item">
              <div class="content-pic">
                <img :src="item.coverUrl" alt />
              </div>
              <div class="content-subject">
                <div class="content-title">{{ item.title }}</div>
                <div class="diver"></div>
                <div class="content-desc">{{ sliceStr(item.content) }}</div>
              </div>
            </div>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    article: Array,
  },
  methods: {
    detail(id) {
      this.$emit("detail", id);
    },
    sliceStr(value) {
      let res = new RegExp("<.+?>","g");
      let content = value.replace(res, '');
      // content.replace(/<[^>]+>|&[^>]+;/g, "");
      content = content.replace(/&nbsp;/ig, "");
      content = content.replace(/&ldquo;/ig, "");
      content = content.replace(/&rdquo;&mdash;&mdash;/ig, "");
      content = content.replace(/&rdquo;/ig, "");
      if (content.length > 100) {
        let str = content.slice(0, 100);
        return `${str}...`;
      } else {
        return content;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.common-content {
  padding: 10px;
  .common-content-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px dashed #dddddd;
    line-height: 40px;
    padding: 10px;
    .content-subject {
      width: 100%;
      margin-left: 20px;
      .content-title {
        color: #333333;
        font-size: 22px;
      }
      .content-desc {
        color: #666666;
        font-size: 16px;
        line-height: 32px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; //需要控制的文本行数
        overflow: hidden;
        // text-overflow: ellipsis;
        word-break: break-all;
        a {
          text-decoration: none;
          color: #b7181e;
        }
      }
      .diver {
        margin-top: 10px;
        width: 100%;
        height: 1px;
        background: #dddddd;
        margin-bottom: 15px;
      }
    }
    .content-pic {
      width: 216px;
      height: 152px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .content-date {
      color: #aaaaaa;
      font-size: 15px;
    }
  }
  ul {
    margin: 0;
    padding: 5px;
    li {
      font-size: 18px;
      list-style: none;
      position: relative;
      a {
        text-decoration: none;
        color: #7d7d7d;
      }
    }
  }
}
</style>